// extracted by mini-css-extract-plugin
module.exports = {"container":"_0fce717cdb--container--ch3SI","hand":"_0fce717cdb--hand--hIE2C"};